import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AdminResetPasswordPage = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (newPassword.length < 6) {
      setErrorMsg('Mật khẩu phải chứa ít nhất 6 ký tự.');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (error) throw error;

      setSuccessMsg('Đổi mật khẩu thành công! Bạn sẽ được chuyển về trang đăng nhập sau 3 giây.');
      setTimeout(() => {
        navigate('/admin/login');
      }, 3000);

    } catch (err) {
      setErrorMsg(err?.message || 'Cập nhật mật khẩu thất bại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-amber-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md backdrop-blur-xl bg-white/95 border border-white/20 rounded-3xl shadow-2xl p-8">
        <h1 className="text-2xl font-extrabold text-slate-900 mb-2 text-center">Đặt Lại Mật Khẩu</h1>
        <p className="text-slate-500 text-sm text-center mb-6">Nhập mật khẩu mới cho tài khoản quản trị của bạn.</p>
        
        <form onSubmit={handleUpdatePassword} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Mật khẩu mới</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 text-slate-900 outline-none focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
              required
            />
          </div>

          {errorMsg && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-2xl px-4 py-3">{errorMsg}</div>}
          {successMsg && <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-2xl px-4 py-3">{successMsg}</div>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold shadow-lg disabled:opacity-60"
          >
            {loading ? "Đang cập nhật..." : "Xác nhận mật khẩu mới"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminResetPasswordPage;